export default __webpack_public_path__ + "b83154a3dc63cdc45428534b969e9f25.png";